/**
 * 信息录入路由文件
 */
import PageFaceInput from '../pages/faceInput/index.vue'
import PageFaceInputGuardian from '../pages/faceInput/guardian.vue'
import PageMemberFace from '../pages/faceInput/memberFace.vue'
import PageMyface from '../pages/faceInput/myface.vue'
import PageRule from '../pages/faceInput/rule.vue'
import PageFaceFrame from '../pages/faceInput/faceFrame.vue'

import { PAGE_IN_MODULE } from '@/utils/constUtils'
const modular = PAGE_IN_MODULE.face
export default [
  {
    path: '/faceInput/index',
    name: 'PageFaceInput',
    component: PageFaceInput,
    meta: {
      modular,
      keepAlive: true,
      title: '信息录入',
      info: '人脸信息录入———首页'
    }
  },
  {
    path: '/faceInput/guardian',
    name: 'PageFaceInputGuardian',
    component: PageFaceInputGuardian,
    meta: {
      modular,
      keepAlive: true,
      title: '家庭人脸管理',
      info: '人脸信息录入———首页———家长端'
    }
  },
  {
    path: '/faceInput/memberface',
    name: 'PageMemberFace',
    component: PageMemberFace,
    meta: {
      modular,
      keepAlive: true,
      title: '学生人脸录入管理',
      info: '人脸信息录入———学生/家长'
    }
  },
  {
    path: '/faceInput/myface',
    name: 'PageMyface',
    component: PageMyface,
    keepAlive: true,
    meta: { modular, title: '人脸录入', info: '人脸信息录入———我的' }
  },
  {
    path: '/faceInput/rule',
    name: 'PageRule',
    component: PageRule,
    meta: {
      modular,
      title: '魔点-儿童生物识别服务规则',
      info: '魔点-儿童生物识别服务规则'
    }
  },
  {
    path: '/faceInput/faceFrame',
    name: 'PageFaceFrame',
    component: PageFaceFrame,
    meta: {
      modular,
      title: '录入人脸',
      info: '录入人脸-iframe'
    }
  }
]
